<template>
  <div class="w-100 d-flex flex-column">



    <Navigation v-if="showNavigation" pageName="remotestats" />

    <!-- graph container -->
    <div class="w-100 p-3">
      <div class="row">
        <div class="col-lg-12 col-sm-12 bg-transparent">

          <!--sezione filtri-->
          <form @submit.prevent="getStats()" class="inline-form">
            <div class="d-flex flex-justify-left pb-1 pr-5">
              <div>
                <select class="pl-2 select text-small mr-2 pl-3 pr-3" v-model="filters.id_group">
                  <option value="">{{ $t("All Groups") }}</option>
                  <option v-for="group in groups" :value="group.id_group" v-bind:key="group.id_group">{{ group.name_group }} </option>
                </select>
              <input type="checkbox" data-role="checkbox" v-model="filters.include_nig" :data-caption="$t('Include remote devices not in the address book')">
              </div>
              <select class="pl-2 select text-small mr-2 pl-3 pr-3" v-model="filters.id_user">
                <option value="">{{ $t("All Users") }}</option>
                <option v-for="user in users" :value="user.id" v-bind:key="user.id">{{ user.username }} </option>
              </select>

              <input type="date" v-model="filters.dt_inf" :max="Date.now() | moment('YYYY-MM-DD')" class="pl-2 select text-small mr-2 pr-3   ">
              <input type="date" v-model="filters.dt_sup" :max="Date.now() | moment('YYYY-MM-DD')" class="pl-2 select text-small mr-2 pr-3  ">
              <input type="button" @click="getStats" :value="$t('Filter')" class="button secondary" :disabled="loading">
            </div>
          </form>

          <!--sezione grafici-->

          <div class="info-box-content mt-3 pos-relative">
            <!-- Lo spinner copre solo i grafici: i filtri rimangono sempre visibili. -->
            <div v-if="loading" class="d-flex flex-align-center flex-justify-center h-100 m-0 p-0 pos-absolute w-100 z-2" style="inset: 0; background: rgba(255, 255, 255, 0.65);">
              <span class="ani-spin fg-darkBlue mif-5x mif-spinner2"></span>
            </div>
            <div class="panel scroll p-4 mb-3" style="height: 74vh;">

              <div class="overflow">

                <div>
                  <div class="row">


                    <!-- GRAFICO 1: numero di sessioni per giorno o mese -->
                    <div class="cell-sm-12 cell-lg-7">
                      <div class="card">
                        <div class="card-header">
                          {{ $t("Number of Sessions per") }}
                          <select class="d-inline-flex select text-small mr-2 pl-3 pr-3 w-auto" v-model="selected" @change="onSelBarUnoChange()">
                            <option disabled value="">{{ $t("Please select one") }}</option>
                            <option value="1">{{ $t("Month") }}</option>
                            <option value="2" selected>{{ $t("Day") }}</option>
                          </select>
                        </div>
                        <!--div v-if="isSeriesBarEmpty" class="card-content p-2">
                                            <img src="/assets/img/icons/no_data.png" class="no-data-img" />
                                            <p class="text-center">{{ $t("Dati non ancora disponibili")}}</p>
                                          </div-->
                        <div class="card-content p-2">
                          <apexchart type="bar" height="380" :options="chartOptions" :series="seriesBar"></apexchart>
                        </div>

                      </div>
                    </div>
                    <!-- GRAFICO 2: distribuzione delle sessioni per operatore -->
                    <div class="cell-sm-12 cell-lg-5">
                      <div class="card">
                        <div class="card-header">
                          {{ $t("% of Sessions per Operator") }}
                        </div>
                        <div class="card-content p-2">
                          <apexchart type="donut" height="408" :options="chartOptionsPie" :series="seriesPie"></apexchart>
                        </div>

                      </div>
                    </div>
                  </div>

                  <div class="row">

                    <!-- GRAFICO 4: durata delle sessioni per giorno o mese -->
                    <div class="cell-sm-12 cell-lg-7">
                      <div class="card">
                        <div class="card-header">
                          {{ $t("Duration of Sessions per") }}
                          <select class="d-inline-flex select text-small mr-2 pl-3 pr-3 w-auto" v-model="selectedLine" @change="onSelLineUnoChange()">
                            <option disabled value="">{{ $t("Please select one") }}</option>
                            <option value="1">{{ $t("Month") }}</option>
                            <option value="2" selected>{{ $t("Day") }}</option>
                          </select>
                        </div>
                        <div class="card-content p-2">
                          <apexchart type="area" height="380" :options="chartOptionsLine" :series="seriesLine"></apexchart>
                        </div>
                      </div>
                    </div>
                    <!-- GRAFICO 5: distribuzione della durata per operatore -->
                    <div class="cell-sm-12 cell-lg-5">
                      <div class="card">
                        <div class="card-header">
                          {{ $t("% of Session Duration per Operator") }}
                        </div>
                        <div class="card-content p-2">
                          <apexchart type="donut" height="380" :options="chartOptionsPieDown" :series="seriesPieDown"></apexchart>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <!-- GRAFICO 6: numero e durata delle sessioni per dispositivo -->
                    <div class="cell-sm-12">
                      <h6>{{ $t("Number and Duration of incoming sessions per device") }}</h6>

                      <div id="chart5">
                        <apexchart type="bar" height="380" :options="chartOptionsBarBottom" :series="chartSeriesBarBottom"></apexchart>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <!-- GRAFICO 7: numero e durata delle sessioni per gruppo -->
                    <div class="cell-sm-12">
                      <h6>{{ $t("Number and Duration of incoming sessions per group") }}</h6>

                      <div id="chart6">
                        <apexchart type="bar" height="380" :options="chartOptionsBarBottomGRP" :series="chartSeriesBarBottomGRP"></apexchart>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <!-- GRAFICO 8: numero e durata delle sessioni per operatore -->
                    <div class="cell-12">
                      <h6>{{ $t("Number and Duration of incoming sessions per operator") }}</h6>

                      <div id="chart7">
                        <apexchart type="bar" height="300" :options="chartOptionsBarBottomUSR" :series="chartSeriesBarBottomUSR"></apexchart>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>



  </div>



</template>
<script>
import { generateShades } from "../../utils/utilitiesmodule";
import Navigation from "../utils/Navigation";
import VueApexCharts from 'vue-apexcharts';
export default {
  name: "StatsRemote",
  components: {
    Navigation,
    apexchart: VueApexCharts
  },
  props: {

    title: {
      type: String,
      required: false
    },
    showNavigation: {
      type: Boolean,
      default: true, // di default lo mostra
    },
  },
  data() {
    return {
      size: 200,
      loading: false,
      groups: this.$session.getGroups(),
      users: this.$session.getUsers(),
      filters: {
        numrows: 25,
        offset: 0,
        lastresult: '',
        dt_inf: this.$moment().subtract(10, 'days').format('YYYY-MM-DD'),
        dt_sup: this.$moment().format('YYYY-MM-DD'),
        id_group: '',
        id_host: '',
        id_user: '',
        include_nig: false,

      },

      maxDate: new Date().toISOString().split('T')[0], // Imposta la data massima come oggi in formato YYYY-MM-DD

      sessions: [],
      filteredSessions: [],
      stats_for_date: [],
      stats_for_date_tml: [],
      stats_for_date_line: [],
      stats_for_date_tmp_line: [],
      selected: "2",
      selectedLine: "2",
      selectedBarBottom: "2",
      // GRAFICO 1 — Numero di sessioni per giorno o mese (barre)
      seriesBar: [{
        data: [0, 0, 0, 0, 0],
      }],
      chartOptions: {
        chart: {
          type: 'bar',
          height: 380
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '20%',
            endingShape: 'rounded'
          },
        },
        colors: ['#001D40'],
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        xaxis: {
          categories: ['', '', '', '', ''],
        },
        yaxis: {
          labels: {
            show: true
          }
        },
        title: {
          text: '',
          align: 'center',
          floating: true
        },
        /*subtitle: {
            text: 'Count the number of sessions for months',
            align: 'center',
        },*/
        tooltip: {
          theme: 'dark',
          x: {
            show: false
          },
          y: {
            title: {
              formatter: function () {
                return ''
              }
            }
          }
        }
      },

      // GRAFICO 2 — Percentuale delle sessioni per operatore (ciambella)
      seriesPie: [0, 0, 0, 0, 0],
      chartOptionsPie: {
        chart: {
          width: 380,
          type: 'donut',
        },
        labels: ['', '', '', '', ''],
        responsive: [{
          breakpoint: undefined,
          options: {
            chart: {
              width: 400,
              height: "100%",
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      },

      // GRAFICO 4 — Durata delle sessioni per giorno o mese (area)
      seriesLine: [{
        name: this.$t("Total time"),
        data: [0, 0, 0, 0, 0]
      }],
      chartOptionsLine: {
        chart: {
          height: 350,
          type: 'area',
          zoom: {
            enabled: false
          }
        },

        dataLabels: {
          enabled: false
        },
        fill: {
          colors: ['#0366d6'], // Colore dell'area sotto la linea
          opacity: 0.3 // Opacità dell'area
        },
        stroke: {
          curve: 'smooth', // Tipo di curva della linea
          colors: ['#253789'], // Colore della linea
          width: 2 // Spessore della linea
        },
        title: {
          text: '',
          align: 'center'
        },
        tooltip: {
          custom: ({ series, seriesIndex, dataPointIndex, w }) => {
            var timeInSeconds = series[seriesIndex][dataPointIndex];
            var formattedTime = this.formatTime(timeInSeconds);
            return '<div class="custom-tooltip">' +
              '<span>' + w.globals.labels[dataPointIndex] + ': ' + formattedTime + '</span>' +
              '</div>';
          }
        },
        /*subtitle: {
            text: 'Count the number of sessions for months',
            align: 'center',
        },*/
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
        },
        xaxis: {
          categories: ['', '', '', '', ''],
        }
      },

      // GRAFICO 5 — Percentuale della durata delle sessioni per operatore (ciambella)
      seriesPieDown: [0, 0, 0, 0, 0],
      chartOptionsPieDown: {
        chart: {
          width: 380,
          type: 'donut',
        },
        labels: ['', '', '', '', ''],
        responsive: [{
          breakpoint: undefined,
          options: {
            chart: {
              width: 400
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      },

      // GRAFICO 6 — Numero e durata delle sessioni per dispositivo (barre)
      chartOptionsBarBottom: {
        chart: {
          type: "bar",
          height: 400,
          zoom: {
            enabled: true
          }
        },

        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '20%' // Imposta la larghezza delle colonne al 20%
          }
        },
        xaxis: {
          categories: [], // Elenco degli id_remote_host
          /*labels: {
            formatter: function(value) {
              // Abbrevia il testo delle categorie
              return value.substring(0, 3); // Mostra solo i primi 3 caratteri
            }
          }*/
          labels: {
            style: {
              fontSize: '8px' // Imposta la dimensione del font a 10 pixel
            }
          }
        },

        toolbar: {
          show: true,
          tools: {
            download: true,

          }
        },
        yaxis: [
          {
            title: {
              text: this.$t("Session number"),
            },
          },
          {
            opposite: true,
            title: {
              text: this.$t("Total time (min)"),
            },
          },
        ],
      },
      chartSeriesBarBottom: [
        {
          name: this.$t('Session number'),
          data: [], // Numero di connessioni per ciascun id_remote_host
        },
        {
          name: this.$t("Total time (min)"),
          data: [], // Tempo totale delle connessioni per ciascun id_remote_host
        },
      ],

      // GRAFICO 7 — Numero e durata delle sessioni per gruppo (barre)
      chartOptionsBarBottomGRP: {
        chart: {
          type: "bar",
          height: 400,

        },

        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '20%' // Imposta la larghezza delle colonne al 20%
          }
        },
        xaxis: {
          categories: [], // Elenco degli id_remote_host
          /*labels: {
              formatter: function(value) {
              // Abbrevia il testo delle categorie
              return value.substring(0, 3); // Mostra solo i primi 3 caratteri
              }
          }*/
          labels: {
            style: {
              fontSize: '8px' // Imposta la dimensione del font a 10 pixel
            }
          }
        },
        /*tooltip: {
            enabled: true,
            y: {
            formatter: function(value) {
                return value + ' connessioni'; // Personalizza il formato del valore del tooltip
            }
            }
        },*/
        toolbar: {
          tools: {
            download: true, // Abilita il download

          }
        },
        yaxis: [
          {
            title: {
              text: this.$t("Session number"),
            },
          },
          {
            opposite: true,
            title: {
              text: this.$t("Total time (min)"),
            },
          },
        ],
      },
      chartSeriesBarBottomGRP: [
        {
          name: this.$t("Session number"),
          data: [], // Numero di connessioni per ciascun id_remote_host
        },
        {
          name: this.$t("Total time (min)"),
          data: [], // Tempo totale delle connessioni per ciascun id_remote_host
        },
      ],

      // GRAFICO 8 — Numero e durata delle sessioni per operatore (barre)
      chartOptionsBarBottomUSR: {
        chart: {
          type: "bar",
          height: 400,

        },
        //colors: ['#0366d6'],
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '20%' // Imposta la larghezza delle colonne al 20%
          }
        },
        xaxis: {
          categories: [], // Elenco degli id_remote_host
          /*labels: {
              formatter: function(value) {
              // Abbrevia il testo delle categorie
              return value.substring(0, 3); // Mostra solo i primi 3 caratteri
              }
          }*/
          labels: {
            style: {
              fontSize: '8px' // Imposta la dimensione del font a 10 pixel
            }
          }
        },
        /*tooltip: {
            enabled: true,
            y: {
            formatter: function(value) {
                return value + ' connessioni'; // Personalizza il formato del valore del tooltip
            }
            }
        },*/
        toolbar: {
          tools: {
            download: true, // Abilita il download
          }
        },

        yaxis: [
          {
            title: {
              text: this.$t("Session number"),
            },
          },
          {
            opposite: true,
            title: {
              text: this.$t("Total time (min)"),
            },
          },
        ],
      },
      chartSeriesBarBottomUSR: [
        {
          name: this.$t("Session number"),
          data: [], // Numero di connessioni per ciascun id_remote_host
        },
        {
          name: this.$t("Total time (min)"),
          data: [], // Tempo totale delle connessioni per ciascun id_remote_host
        },
      ],



    }
  },
  created() {
    this.$session.setRoomPC(null);
    this.$root.socket("SETPC", null);
    this.getStats();

  },

  methods: {


    // Supporto GRAFICO 4: formatta la durata mostrata nel tooltip.
    formatTime(seconds) {
      var hours = Math.floor(seconds / 3600);
      var minutes = Math.floor((seconds % 3600) / 60);
      var remainingSeconds = seconds % 60;
      return hours + 'h ' + minutes + 'm ' + remainingSeconds + 's';
    },



    getStats() {
      let self = this;

      self.sessions = [];
      self.stats_for_date_tmp = {};
      self.stats_for_date = {};
      self.stats_for_date_tmp_line = {};
      self.stats_for_date_line = {};
      self.filteredSessions = [];

      const baseColor = '210'; // blu cielo

      self.loading = true;
      //self.fullStats = await this.$api.getStatsFromLicense(self.filters.dt_inf,self.filters.dt_sup);
      //self.sessions =  await this.$api.getRemoteStats( self.filters);

      const requestFilters = {
        ...self.filters,
        id_group: self.filters.include_nig && self.filters.id_group === '' ? 'NIG' : self.filters.id_group
      };

      this.$api.getSessions(requestFilters)
        .then(function (response) {
          if (response) {

            // GRAFICI 1 e 4 — Numero e durata delle sessioni per giorno o mese.
            if (response.stats_per_date) {
              self.stats_for_date_tmp = response.stats_per_date;
              self.stats_for_date_tmp_line = response.stats_per_date;

              // GRAFICO 1 — Numero di sessioni per periodo.
              if (self.selected == '1') {
                self.stats_for_date = self.raggruppaPerMese(self.stats_for_date_tmp)
                // creazione di due array separati per le etichette (mesi) e i dati (count)
                const etichetteMesi = Object.keys(self.stats_for_date).sort();
                self.aggiornaCategorieColumnChart(etichetteMesi);
                const datiCount = etichetteMesi.map(mese => self.stats_for_date[mese].count);
                //self.series[0].data = datiCount
                self.seriesBar = [{
                  data: datiCount
                }];
              } else {
                // creazione di due array separati per le etichette (mesi) e i dati (count)
                const etichetteGiorni = Object.keys(self.stats_for_date_tmp).sort();
                self.aggiornaCategorieColumnChart(etichetteGiorni);
                // Ottenere i dati per il conteggio per ogni giorno
                const datiCount = Object.values(self.stats_for_date_tmp).map(day => day.count);
                //self.series[0].data = datiCount
                self.seriesBar = [{
                  data: datiCount
                }];
              }
              // GRAFICO 4 — Durata delle sessioni per periodo.
              if (self.selectedLine == '1') {
                self.stats_for_date_line = self.raggruppaPerMese(self.stats_for_date_tmp_line)
                // creazione di due array separati per le etichette (mesi) e i dati (count)
                const etichetteMesiLine = Object.keys(self.stats_for_date_line).sort();
                self.aggiornaCategorieLineChart(etichetteMesiLine);
                const datiTimeLine = etichetteMesiLine.map(mese => self.stats_for_date_line[mese].total_time);

                self.seriesLine = [{
                  data: datiTimeLine
                }];
              } else {
                // creazione di due array separati per le etichette (mesi) e i dati (count)
                const etichetteGiorniLine = Object.keys(self.stats_for_date_tmp_line).sort();
                self.aggiornaCategorieLineChart(etichetteGiorniLine);
                // Ottenere i dati per il conteggio per ogni giorno
                const datiTimeline = Object.values(self.stats_for_date_tmp_line).map(day => day.total_time);
                self.seriesLine = [{
                  data: datiTimeline
                }];

              }
            }

            // GRAFICI 2, 5, 6, 7 e 8 — Aggregazioni per operatore, dispositivo e gruppo.
            if (response.stats_per_user) {
              // Calcola la somma totale di conteggio e tempo
              const totalCount = Object.values(response.stats_per_user).reduce((acc, user) => acc + user.count, 0);
              const totalTime = Object.values(response.stats_per_user).reduce((acc, user) => acc + user.total_time, 0);

              // Calcola la percentuale di conteggio e tempo per ciascun utente
              const userData = Object.keys(response.stats_per_user).map(userId => {
                const user = response.stats_per_user[userId];
                return {
                  userId: userId,
                  detailcountuser: user.count,
                  detailusertime: user.total_time,
                  countPercentage: +(Math.round(((user.count / totalCount) * 100) + "e+2") + "e-2"),
                  //timePercentage: +(Math.round(((user.total_time / totalCount) * 100) + "e+2") + "e-2")
                  timePercentage: Math.round((user.total_time / totalTime) * 100)
                };
              });

              // Genera colori varianti su base blu
              const colors = generateShades(baseColor, userData.length);


              // GRAFICO 2 — Percentuale del numero di sessioni per operatore.
              self.chartOptionsPie = {
                theme: {

                  /* monochrome: {
                    enabled: true,
                    color: '#253789',
                    shadeTo: 'light',
                    shadeIntensity: 0.65
                  }, */
                },
                labels: userData.map(user => user.userId.split('|')[1]),
                legend: {
                  position: 'bottom',
                  formatter: function (seriesName, opts) {
                    const maxLength = 30;
                    return seriesName.length > maxLength
                      ? seriesName.substring(0, maxLength) + '...'
                      : seriesName;
                  }
                },
                tooltip: {
                  style: {
                    fontSize: '14px',
                    fontFamily: 'Poppins, Helvetica, Arial, sans-serif',
                    background: '#1f1f1f',  // Colore sfondo tooltip
                    color: '#ffffff'        // Colore testo tooltip
                  },
                  fillSeriesColor: false,
                  theme: false // Disattiva il tema predefinito (dark/light) per usare colori personalizzati
                },
                //colors: ['#d22437', '#117757', '#ffc107', '#cccccc'], // ← qui metti i colori
                colors: colors
              };
              self.seriesPie = userData.map(user => user.detailcountuser);

              // GRAFICO 5 — Percentuale della durata delle sessioni per operatore.
              self.chartOptionsPieDown = {
                theme: {
                  /* monochrome: {
                    enabled: true,
                    color: '#253789',
                    shadeTo: 'light',
                    shadeIntensity: 0.65
                  }, */
                },
                labels: userData.map(user => user.userId.split('|')[1]),
                legend: {
                  position: 'bottom',
                  formatter: function (seriesName, opts) {
                    const maxLength = 30;
                    return seriesName.length > maxLength
                      ? seriesName.substring(0, maxLength) + '...'
                      : seriesName;
                  }
                },
                tooltip: {
                  style: {
                    fontSize: '14px',
                    fontFamily: 'Poppins, Helvetica, Arial, sans-serif',
                    background: '#1f1f1f',  // Colore sfondo tooltip
                    color: '#ffffff'        // Colore testo tooltip
                  },
                  fillSeriesColor: false,
                  theme: false // Disattiva il tema predefinito (dark/light) per usare colori personalizzati
                },
                colors: colors, // ← qui metti i colori
              };
              self.seriesPieDown = userData.map(user => Math.round(user.detailusertime / 60));
              // GRAFICO 6 — Numero e durata delle sessioni per dispositivo host.
              const sessions = response.sessions;
              const groupedData = {};

              // Calcola il numero di connessioni e il tempo totale per ogni gruppo
              for (const session of sessions) {
                //const key = `${session.id_remote_host}-${session.id_user}`;
                const key = `${session.id_remote_host}`;
                if (!groupedData[key]) {
                  groupedData[key] = {
                    id_remote_host: session.id_remote_host + ' (' + session.custom_name + ')',
                    numConnections: 0,
                    totalTime: 0,
                  };
                }
                groupedData[key].numConnections++;
                groupedData[key].totalTime += session.total_time;
              }

              // Prepara i dati per ApexCharts
              const categories = [];
              const numConnections = [];
              const totalTimebb = [];

              for (const key in groupedData) {
                const group = groupedData[key];
                categories.push(group.id_remote_host);
                numConnections.push(group.numConnections);
                totalTimebb.push(Math.round(group.totalTime / 60));
              }

              // Aggiorna i dati del grafico
              self.aggiornaCategorieBarBottomChart(categories);
              self.chartSeriesBarBottom[0].data = numConnections;
              self.chartSeriesBarBottom[1].data = totalTimebb;
              // GRAFICO 7 — Numero e durata delle sessioni per gruppo.
              const groupedDataGRP = {};

              // Calcola il numero di connessioni e il tempo totale per ogni gruppo
              for (const sessionGRP of sessions) {
                const key = `${sessionGRP.group_id}`;
                if (!groupedDataGRP[key]) {
                  groupedDataGRP[key] = {
                    groupname: sessionGRP.group_name,
                    numConnections: 0,
                    totalTime: 0,
                  };
                }
                groupedDataGRP[key].numConnections++;
                groupedDataGRP[key].totalTime += sessionGRP.total_time;
              }

              // Prepara i dati per ApexCharts
              const categoriesGRP = [];
              const numConnectionsGRP = [];
              const totalTimebbGRP = [];

              for (const key in groupedDataGRP) {
                const groupGRP = groupedDataGRP[key];
                categoriesGRP.push(groupGRP.groupname);
                //categories.push(group.id_user);
                numConnectionsGRP.push(groupGRP.numConnections);
                totalTimebbGRP.push(Math.round(groupGRP.totalTime / 60));
              }

              // Aggiorna i dati del grafico
              self.aggiornaCategorieBarBottomChartGRP(categoriesGRP);

              self.chartSeriesBarBottomGRP[0].data = numConnectionsGRP;
              self.chartSeriesBarBottomGRP[1].data = totalTimebbGRP;
              // GRAFICO 8 — Numero e durata delle sessioni per operatore.
              const groupedDataUSR = {};

              // Calcola il numero di connessioni e il tempo totale per ogni gruppo
              for (const sessionUSR of sessions) {
                const key = `${sessionUSR.id_user}`;
                if (!groupedDataUSR[key]) {
                  groupedDataUSR[key] = {
                    userfullname: sessionUSR.firstname + ' ' + sessionUSR.lastname,
                    numConnections: 0,
                    totalTime: 0,
                  };
                }
                groupedDataUSR[key].numConnections++;
                groupedDataUSR[key].totalTime += sessionUSR.total_time;
              }

              // Prepara i dati per ApexCharts
              const categoriesUSR = [];
              const numConnectionsUSR = [];
              const totalTimebbUSR = [];

              for (const key in groupedDataUSR) {
                const groupUSR = groupedDataUSR[key];
                categoriesUSR.push(groupUSR.userfullname);
                numConnectionsUSR.push(groupUSR.numConnections);
                totalTimebbUSR.push(Math.round(groupUSR.totalTime / 60));
              }

              // Aggiorna i dati del grafico
              self.aggiornaCategorieBarBottomChartUSR(categoriesUSR);

              self.chartSeriesBarBottomUSR[0].data = numConnectionsUSR;
              self.chartSeriesBarBottomUSR[1].data = totalTimebbUSR;
            }


          }
        })
        .catch(e => {
          //self.errors.push(e)
          //self.toastr["info"](self.errors);
        })
        .finally(() => {
          self.loading = false;
        })



      //if (self.sessions.sessions.length != 0)  self.statsPerDateChart(self.sessions.stats_per_date);
      //if (self.sessions.sessions.length != 0)  self.statsPerUserChart(self.sessions.stats_per_user);
      //if (self.sessions.sessions.length != 0)  self.statsPerUserCake(self.sessions.stats_per_user);
      //if (self.fullStats.dataStats.length != 0)  self.dataBackupChart(self.fullStats.dataStats);

      //if (self.fullStats!=null && self.fullStats.nOfServers + self.fullStats.nOfWorkstations != 0)  self.computerTypeChart();
      //if (self.fullStats.nPcDanger + self.fullStats.nPcOk + self.fullStats.nPcWarning != 0)  self.computerHealtChart();
    },

    // Interazione GRAFICO 1: aggiorna il raggruppamento giorno/mese.
    onSelBarUnoChange() {

      var self = this;

      // Ricostruzione dei dati del grafico a barre.
      if (self.selected == '1') {
        self.stats_for_date = self.raggruppaPerMese(self.stats_for_date_tmp)
        // creazione di due array separati per le etichette (mesi) e i dati (count)
        const etichetteMesi = Object.keys(self.stats_for_date).sort();
        self.aggiornaCategorieColumnChart(etichetteMesi);
        const datiCount = etichetteMesi.map(mese => self.stats_for_date[mese].count);
        //app.series[0].data = datiCount
        self.seriesBar = [{
          data: datiCount
        }];
      }
      if (self.selected == '2') {
        // creazione di due array separati per le etichette (mesi) e i dati (count)
        const etichetteGiorni = Object.keys(self.stats_for_date_tmp).sort();
        self.aggiornaCategorieColumnChart(etichetteGiorni);
        // Ottenere i dati per il conteggio per ogni giorno
        const datiCount = Object.values(self.stats_for_date_tmp).map(day => day.count);
        //app.series[0].data = datiCount
        self.seriesBar = [{
          data: datiCount
        }];
      }
    },
    // Interazione GRAFICO 4: aggiorna il raggruppamento giorno/mese.
    onSelLineUnoChange() {

      let self = this;

      // Ricostruzione dei dati del grafico ad area.
      if (self.selectedLine == '1') {
        self.stats_for_date_line = self.raggruppaPerMese(self.stats_for_date_tmp_line)
        // creazione di due array separati per le etichette (mesi) e i dati (count)
        const etichetteMesiLine = Object.keys(self.stats_for_date_line).sort();
        self.aggiornaCategorieLineChart(etichetteMesiLine, self.chartOptionsLine);
        const datiTimeLine = etichetteMesiLine.map(mese => self.stats_for_date_line[mese].total_time);
        self.seriesLine = [{
          data: datiTimeLine
        }];
      }
      if (self.selectedLine == '2') {
        // creazione di due array separati per le etichette (mesi) e i dati (count)
        const etichetteGiorniLine = Object.keys(self.stats_for_date_tmp_line).sort();
        self.aggiornaCategorieLineChart(etichetteGiorniLine, self.chartOptionsLine);
        // Ottenere i dati per il conteggio per ogni giorno
        const datiTimeline = Object.values(self.stats_for_date_tmp_line).map(day => day.total_time);
        self.seriesLine = [{
          data: datiTimeline
        }];
      }
      // ---------------------------------------------------------------------------------------------
    },


    // Aggiorna le categorie dell'asse X del GRAFICO 1.
    aggiornaCategorieColumnChart(categorieNuove) {


      let self = this;

      self.chartOptions = {
        ...self.chartOptions,
        xaxis: { ...self.chartOptions.xaxis, categories: categorieNuove }
      };


    },

    // Aggiorna le categorie dell'asse X del GRAFICO 4.
    aggiornaCategorieLineChart(categorieNuove) {

      let self = this;

      self.chartOptionsLine = {
        ...self.chartOptionsLine,
        xaxis: { ...self.chartOptionsLine.xaxis, categories: categorieNuove }
      };
    },

    // Aggiorna le categorie dell'asse X del GRAFICO 6.
    aggiornaCategorieBarBottomChart(categorieNuove) {

      let self = this;


      self.chartOptionsBarBottom = {
        ...self.chartOptionsBarBottom,
        xaxis: { ...self.chartOptionsBarBottom.xaxis, categories: categorieNuove }
      };
    },

    // Aggiorna le categorie dell'asse X del GRAFICO 8.
    aggiornaCategorieBarBottomChartUSR(categorieNuove) {

      let self = this;

      self.chartOptionsBarBottomUSR = {
        ...self.chartOptionsBarBottomUSR,
        xaxis: { ...self.chartOptionsBarBottomUSR.xaxis, categories: categorieNuove }
      };
    },

    // Aggiorna le categorie dell'asse X del GRAFICO 7.
    aggiornaCategorieBarBottomChartGRP(categorieNuove) {

      let self = this;

      self.chartOptionsBarBottomGRP = {
        ...self.chartOptionsBarBottomGRP,
        xaxis: { ...self.chartOptionsBarBottomGRP.xaxis, categories: categorieNuove }
      };
    },

    // raggruppa i risultati (raggruppati per giorni) in mesi delle statistiche inviati da api  
    raggruppaPerMese(stats) {
      const risultatiPerMese = {};

      Object.entries(stats).forEach(([data, { count, total_time }]) => {
        const mese = data.substr(0, 7); // Estrae l'anno e il mese dalla data

        if (!risultatiPerMese[mese]) {
          risultatiPerMese[mese] = { count: 0, total_time: 0 };
        }

        risultatiPerMese[mese].count += count;
        risultatiPerMese[mese].total_time += total_time;
      });

      return risultatiPerMese;
    },
    // #######################################################################################################



  }
}
</script>
